import ShariffTooltip from './shariffTooltip';
import React from 'react';
import Shariff from 'shariff';
import $ from 'jquery';
import { translate } from 'react-i18next';

function ActionWidget({ t, calendarImport, contactImport, bookmark, articleId }) {
  // we use shariff for social sharing
  // https://github.com/heiseonline/shariff
  // https://www.npmjs.com/package/shariff
  function shariffTooltip(e) {
    e.preventDefault();
    const $shariff = $('.shariff'),
      $actionWidgetTooltipWrapper = $('.action-widget .tooltip-wrapper');

    /* eslint-disable no-new */
    // shariff should be used like this without storing in a variable
    new Shariff($shariff, { lang: t('locale') });

    $actionWidgetTooltipWrapper.stop(true, false).fadeToggle(200);

    $('body').click((e2) => {
      // check if the clicked element is not a descendant of the tooltip
      if (!$(e2.target).closest('.action-widget .tooltip-wrapper').length) {
        // hide the tooltip
        $actionWidgetTooltipWrapper.stop(true, false).fadeOut(200);
      }
    });
  }

  function print(e) {
    e.preventDefault();
    window.print();
  }

  function bookmarkAlert(e) {
    e.preventDefault();

    const keyCombo =
      navigator.userAgent.toLowerCase().indexOf('mac') !== -1 ? 'Command/Cmd' : 'CTRL';

    if (document.all && window.external) {
      // Internet Explorer
      /* eslint-disable new-cap */
      // https://msdn.microsoft.com/en-us/library/ms535926(v=vs.85).aspx
      window.external.AddFavorite(location.href, document.title);
    } else {
      // Firefox, Safari, Chrome, Opera, ...
      /* eslint-disable no-alert */
      // we want to see this alert to give advice to the user
      alert(`${t('bookmarkAlert1')}: ${keyCombo} D, ${t('bookmarkAlert2')}.`);
    }
  }

  function icalUrl() {
    return `/ical/${articleId}.ics`;
  }

  function vcardUrl() {
    return `/vcard/${articleId}.vcf`;
  }

  function pdfUrl() {
    return `${location.href}.pdf`;
  }

  function showCalendarImport() {
    if (!calendarImport) {
      return null;
    }

    return (
      <li>
        <a href={icalUrl()} rel="nofollow" title={t('calendar')}>
          <i className="fa fa-calendar-plus-o" />
          <span className="color-secondary">{t('calendar')}</span>
        </a>
      </li>
    );
  }

  function showContactImport() {
    if (!contactImport) {
      return null;
    }

    return (
      <li>
        <a href={vcardUrl()} rel="nofollow" title={t('contact')}>
          <i className="fa fa-address-card-o" />
          <span className="color-secondary">{t('contact')}</span>
        </a>
      </li>
    );
  }

  function showShare() {
    return (
      // we use shariff for social sharing
      // https://github.com/heiseonline/shariff
      <li>
        <a href="#" onClick={shariffTooltip} title={t('share')}>
          <i className="fa fa-share-alt" />
          <span className="color-secondary">{t('share')}</span>
        </a>
        <ShariffTooltip />
      </li>
    );
  }

  function showPrint() {
    return (
      <li>
        <a href="#" onClick={print} title={t('print')}>
          <i className="fa fa-print" />
          <span className="color-secondary">{t('print')}</span>
        </a>
      </li>
    );
  }

  function showBookmark() {
    if (!bookmark) {
      return null;
    }

    return (
      <li>
        <a href="#" onClick={bookmarkAlert} title={t('bookmark')}>
          <i className="fa fa-bookmark" />
          <span className="color-secondary">{t('bookmark')}</span>
        </a>
      </li>
    );
  }

  /* eslint-disable no-unused-vars */
  // QB-545 - PDF function will be implemented later
  function showPdf() {
    return (
      <li>
        <a href={pdfUrl()} target="_blank" className="make-pdf" rel="nofollow" title="PDF">
          <i className="fa fa-file-pdf-o" />
          <span className="color-secondary">PDF</span>
        </a>
      </li>
    );
  }

  return (
    <div className="action-widget-wrapper">
      <ul className="action-widget">
        {showCalendarImport()}
        {showContactImport()}
        {showShare()}
        {/*
          showPrint()

          QPB-437 - removed print function
        */}
        {showBookmark()}

        {/*
          showPdf()

          QB-545 - PDF function will be implemented later
        */}
      </ul>
    </div>
  );
}

ActionWidget.propTypes = {
  t: React.PropTypes.func,
  calendarImport: React.PropTypes.bool,
  contactImport: React.PropTypes.bool,
  bookmark: React.PropTypes.bool,
  articleId: React.PropTypes.number
};

export default translate()(ActionWidget);



// WEBPACK FOOTER //
// ./components/widgets/actionWidget.js